export const connectWallet = 'connectWalletData'

export const removeWallet = 'removeWalletData'